export default {
  name: 'reportes',
  component: () =>
    import(
      /* webpackChunkName: "reportesLayout" */ "@/modules/reportes/layouts/reportesLayout.vue"
    ),
  redirect: "/reportes/general",
  children: [
    {
      path: "general",
      name: "reportes-general-pbx",
      component: () =>
        import(
          /* webpackChunkName: "directorio" */ "@/modules/reportes/pages/General.vue"
        ),
    },
    {
      path: "detalle",
      name: "reportes-detalle-pbx",
      component: () =>
        import(
          /* webpackChunkName: "detalle" */ "@/modules/reportes/pages/Detalle.vue"
        ),
    },
    {
      path: "compania",
      name: "reportes-compania",
      component: () =>
        import(
          /* webpackChunkName: "compania" */ "@/modules/reportes/pages/Compania.vue"
        ),
    },
    {
      path: "encuestas",
      name: "reportes-encuestas",
      component: () =>
        import(
          /* webpackChunkName: "encuestas" */ "@/modules/reportes/pages/Encuestas.vue"
        ),
    },
    {
      path: "etiquetas",
      name: "reportes-etiquetas",
      component: () =>
        import(
          /* webpackChunkName: "etiquetas-llamadas" */ "@/modules/reportes/pages/Etiquetas.vue"
        ),
    },
    {
      path: "llamadas",
      name: "reportes-llamadas",
      component: () =>
        import(
          /* webpackChunkName: "llamadas-pbx" */ "@/modules/reportes/pages/Llamadas.vue"
        ),
    },
    {
      path: "perdidas",
      name: "reportes-perdidas",
      component: () =>
        import(
          /* webpackChunkName: "perdidas" */ "@/modules/reportes/pages/MissedCalls.vue"
        ),
    },
    {
      path: "extensiones",
      name: "reportes-extensiones",
      component: () =>
        import(
          /* webpackChunkName: "extensiones" */ "@/modules/reportes/pages/Extensiones.vue"
        ),
    },
    {
      path: "ivrs",
      name: "reportes-ivrs",
      component: () =>
        import(
          /* webpackChunkName: "ivrs" */ "@/modules/reportes/pages/Ivrs.vue"
        ),
    },
    {
      path: "encuestas-ivrs",
      name: "reportes-encuestas-ivrs",
      component: () =>
        import(
          /* webpackChunkName: "encuestas-ivrs" */ "@/modules/reportes/pages/IvrSurveys.vue"
        ),
    },
    {
      path: "colas",
      name: "reportes-colas",
      component: () =>
        import(
          /* webpackChunkName: "colas" */ "@/modules/reportes/pages/Colas.vue"
        ),
    },
    {
      path: "curso",
      name: "reportes-curso",
      component: () =>
        import(
          /* webpackChunkName: "curso" */ "@/modules/reportes/pages/CallInProgress.vue"
        ),
    },
    
  ],
}